import type {NavigationSections} from '@cohort/wallet/hooks/spaceNavigation';

export type CSSSection =
  | 'global.footer'
  | 'home.achievements'
  | 'home.achievements.challenges'
  | 'home.achievements.rewards'
  | 'home.challenges'
  | 'home.contents'
  | 'home.membership-pass'
  | 'home.rewards'
  | 'home.rewards.reward-boxes'
  | 'home.rewards.digital-assets'
  | 'home.rewards.perks'
  | 'home.badges'
  | 'home.about'
  | 'challenge.faq'
  | 'challenge.rewards'
  | 'challenge.steps'
  | 'settings.user-handle'
  | 'membership-pass.member-handle'
  | 'membership-pass.member-id'
  | 'membership-pass.joined-at'
  | 'navigation.profile'
  | `navigation.${(typeof NavigationSections)[number]}`;

export function getPageAndSectionFromCssSection(sectionName: CSSSection): [string, string] {
  const [page, ...rest] = sectionName.split('.');
  const section = rest.join('-');

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return [page!, section];
}

export function enableVisibilityProperty(sectionName: CSSSection): {
  display?: string | undefined;
} {
  const [page, section] = getPageAndSectionFromCssSection(sectionName);
  const visibility = getComputedStyle(document.documentElement).getPropertyValue(
    `--xps-section-${page}-${section}-visibility`
  );

  return {
    display: visibility === 'hidden' ? 'none' : undefined,
  };
}

export function enableOrderAndVisibilityProperties(sectionName: CSSSection): {
  display?: string | undefined;
  order: string;
} {
  const [page, section] = getPageAndSectionFromCssSection(sectionName);

  return {
    ...enableVisibilityProperty(sectionName),
    order: `var(--xps-section-${page}-${section}-order)`,
  };
}
